
import React, {  useContext, useEffect, useState } from 'react'
import { useMutation } from 'react-query'
import {ContextType, verificationContext } from '../context/VerificationContext'
import {  Typography, IconButton, Divider, List, ListItem, ListItemText } from '@mui/material'
import EditNoteIcon from '@mui/icons-material/EditNote';
import ErrorIcon from '@mui/icons-material/Error';
import { getPhysicalExamination } from '../../../EMR/services'
import usePopup from '../../../hooks/usePopup'
// import PatientAllergy from '../../../EMR/components/Allergy'
import { PhysicalExaminationListType } from '../../../EMR/components/PhysicalExamination/types'
import PhysicalExamination from '../../../EMR/components/PhysicalExamination';
function PhysicalExaminationTable() {
  
    const {searchData}=useContext(verificationContext) as ContextType
    const [tableData,setTableData]=useState<PhysicalExaminationListType[]|[]>([])
    const [open,setOpen] = useState<boolean>(false)
    const {mutate:getExamination}=useMutation(getPhysicalExamination,{onSuccess:(data)=>{setTableData(data.response)
     }})
    const {CustomModal} = usePopup()
    useEffect(()=>{
        if(searchData?.encounter?.encounterId){
            getExamination(`${searchData?.encounter?.encounterId}`)
        }
    },[searchData?.encounter?.encounterId])


    const closepopUp=()=>{
        getExamination(`${searchData?.encounter?.encounterId}`)
      setOpen(false)
    }
  return (
    <>

    <CustomModal  title='physical examination' open={open} setOpen={setOpen} handleClose={()=>{closepopUp()}} >

          <div className='max-h-[70dvh]   p-2 overflow-auto' >
            <PhysicalExamination component='Examination' />
          </div>
    </CustomModal>
<div className='flex  justify-between me-5'>
       <Typography className="!ml-2">
          <strong>Physical Examination</strong>
      </Typography>
      <IconButton edge="end" aria-label="delete" onClick={()=>setOpen(true)}>
               <EditNoteIcon color='primary' />
       </IconButton>
</div>
<Divider />
      <List>
          {
           tableData?.length>0 ?(  tableData?.map((item)=>{
              return(
               <>
                  <ListItem alignItems="flex-start">
                  <ListItemText
                  primary={`${item.description}`}
                  secondary={
                    <React.Fragment>
                      <Typography
                        component="span"
                        variant="body2"
                        sx={{ color: 'text.primary', display: 'inline' }}
                      >
                      
                      </Typography>
                 
                    </React.Fragment>
                  }
                />
                  </ListItem>
                <Divider />
               </>
              )
             })):  
             <div className="col-span-12 flex justify-center items-center flex-col gap-2">
             <ErrorIcon color="info" sx={{fontSize:"2rem"}}/>
             No Physical examination found
           </div>
           }
</List>
    </>
  )
}

export default PhysicalExaminationTable

